import { createRoute } from '@tanstack/react-router';

import { InvitationPage } from '$/pages/InvitationPage';
import { RootRoute } from '$/routes/RootRoute';
import { STANDARD_STALE_TIME } from '$/services/constants';

export const InvitationRoute = createRoute({
  getParentRoute: () => RootRoute,
  path: '/invitation/$id',
  component: InvitationPage,
  staleTime: STANDARD_STALE_TIME,
});
